<template>
  <div id="fontList" ref="fontList">
    <el-select v-model="selectedFont"
      :popper-class="'select-font-list'"
      @change="handleFontSelectionChange" id="selectFont" :placeholder="$t('label.select')" class="cstm-selectbox-grey">
      <el-option
        v-for="(font, indx) in fontList.family"
        :key="indx"
        :label="font"
        :value="font">
      </el-option>

      <!-- File Upload -->
      <el-option class="add-icon" key="addFont" :label="'-'" :value="'addFont'">
        <div v-if="fontUpload.action !== null && isUploadFontVisibile" id="uploadFont">
          <el-upload
            id="fontUploader"
            drag
            :action="fontUpload.action"
            :data="fontUpload.data"
            :show-file-list="false"
            :on-change="handleFontUploadChange"
            :on-success="handleFontUploadSuccess"
            :on-error="handleFontUploadError"
            :before-upload="handleFontBeforeUpload"
            multiple>
          </el-upload>
        </div>
      </el-option>
    </el-select>

  </div>
</template>

<script src="./font-list.js"></script>
<style lang="scss" src="./font-list.scss"></style>
